<template>
  <onboard-wrap>
    <template slot="content">
      <header class="text-center">
        <h1 class="h3">Start your 7-day free trial now</h1>
        <p>Don't give Wi-Fi snoops another chance to act.</p>
      </header>
      <payment-teams :config="paymentConfig" :pricing="pricing" @chargeResponse="payResponse" :modal="true"></payment-teams>
    </template>
    <template slot="extra">
      <div class="element xs centered text-center">
        <ul>
          <li>
            <img src="./images/add.svg" alt="">
            <p>Next, you’ll invite users to join your team and try TunnelBear free along with you.</p>
          </li>
          <li>
            <img src="./images/pay.svg" alt="">
            <p>On {{endOfTrialDate}}, you’ll be charged $69/year for each user on your team.</p>
          </li>
          <li>
            <img src="./images/refund.svg" alt="">
            <p>Try it with zero risk. Not happy? Cancel your trial to avoid being charged.</p>
          </li>
        </ul>
      </div>
    </template>
  </onboard-wrap>
</template>

<script>
import paymentTeams from '@/components/payment-teams/payment-teams'
import services from '@/services/services.js'
import onboardWrap from '@/components/onboard-wrap/onboard-wrap'

export default {
  name: 'pay',
  components: {
    'payment-teams': paymentTeams,
    'onboard-wrap': onboardWrap
  },
  data () {
    return {}
  },
  created: function () {
    if (!this.$store.state.newTeam.teamName) {
      this.$router.push({name: 'name'})
    }
    this.$store.dispatch('getPricingData')
  },
  computed: {
    paymentConfig: function () {
      return {
        productName: 'TB4T_YEARLY_PAYMENT_TRIAL',
        endpoint: '/team/create',
        name: this.$store.state.newTeam.teamName,
        industry: this.$store.state.newTeam.industry
      }
    },
    endOfTrialDate: function () {
      let date = new Date()
      let sevenDays = 7 * 24 * 60 * 60 * 1000
      let sevenDaysFromNow = new Date(date.getTime() + sevenDays)
      return services.formatDate(sevenDaysFromNow)
    },
    pricing: function () {
      return this.$store.getters.pricingDetails
    }
  },
  methods: {
    payResponse: function (result) {
      if (result === 'PASS') {
        this.$router.push({ name: 'invite' })
      }
      this.$store.dispatch('getUserData', true)
    }
  }
}
</script>

<style scoped lang="stylus" src="./pay.styl" >



// WEBPACK FOOTER //
// src/views/onboarding/views/pay/pay.vue